import Entity from "@/services/westore/entities/entity";


class OrderReturn extends Entity {
    static uri = '/order-returns';

    static store(payloadRequest) {
        return super.create(OrderReturn.uri, payloadRequest)
    }

    static getOne(id, params = {}) {
        return super.get(OrderReturn.uri, id, params)
    }

    static getAll(params = {}) {
        return super.getAll(OrderReturn.uri, params)
    }

    static cancel(id) {
        let uri = `${OrderReturn.uri}/${id}/cancel`;
        return super.put({uri})
    }

    static export(type = 'xlsx', filter) {
        const endpoint = `${OrderReturn.uri}/export?type=${type}`;
        return super.get(endpoint, null, filter);
    }
}

export default OrderReturn;